import { render, staticRenderFns } from "./DraggableResizableRotatable.vue?vue&type=template&id=62bca73a"
import script from "./DraggableResizableRotatable.vue?vue&type=script&setup=true&lang=ts"
export * from "./DraggableResizableRotatable.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./DraggableResizableRotatable.vue?vue&type=style&index=0&id=62bca73a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports